export default __webpack_public_path__ + "static/media/1.1da00f2f.svg";